export default __webpack_public_path__ + "static/travel2-42eafc58dd10c07852936a38f6e8b79a.png";